import sys from '../system';
import { App, defineCustomElement } from "vue";

import { vue } from '@truckdown/jsclient/icons';

import captcha from './captcha/captcha.ce.vue';
import pageHeader from './pageHeader/pageHeader.vue';
import contextInfo from './contextInfo/contextInfo.vue';
import controlPanel from './controlPanel/controlPanel.vue';
import primaryHeader from './primaryHeader/primaryHeader.vue';
import primaryFooter from './primaryFooter/primaryFooter.vue';

//template components 
sys.app.component('context-info', contextInfo);
sys.app.component('control-panel', controlPanel);
sys.app.component('primary-header', primaryHeader);
sys.app.component('primary-footer', primaryFooter);

export default (app: App<Element>) => {
    app.component('fa-icon', vue.FontAwesomeIcon);

    app.component('captcha', captcha);
    app.component('page-header', pageHeader);

    const CaptchaControlCustomElement = defineCustomElement(captcha)
    if (customElements) {
        customElements.define('captcha-control', CaptchaControlCustomElement)
    }
    app.config.compilerOptions.isCustomElement = tag => tag === 'captcha-control'
}
